import _ from 'lodash';

export const getRouteClaimId = () => {
    const claimId = getClaimIdHref() || getClaimIdState();
    return isUuid(claimId) ? claimId : undefined;
};

export const getClaimIdHref = (): string | undefined => {
    const claimIdRegex = RegExp(/claims\/([\w-]+)/gi);

    const match = claimIdRegex.exec(window.location.href);

    return match ? match[1] : undefined;
};

export const getClaimIdState = (): string | undefined => {
    return _.get(history, 'location.state.claimId');
};

const isUuid = (id?: string): boolean => {
    if (!id) {
        return false;
    }

    return /^[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/i.test(id);
};
